import type {Page, Result, UseCase} from 'framework';
import type {Product} from '../../domain/product';
import type {ProductError} from '../../domain/errors';
import type {ProductRepository} from '../ports/product.repository';

export type ListProductsInput = {
  readonly cursor: string | null;
  readonly q: string;
};

export class ListProducts implements UseCase<[ListProductsInput], Page<Product>> {
  constructor(private readonly repository: ProductRepository) {}

  execute(input: ListProductsInput): Promise<Result<Page<Product>, ProductError>> {
    return this.repository.list(input);
  }
}
